/** @jsx jsx */

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "@fontsource/baloo-2"
import PropTypes from "prop-types"
import { jsx } from "theme-ui"

import "./Layout.css"
import { Seo } from "./Seo"
import { NavHeader } from "./NavHeader"
import { Footer } from "./Footer"

export const Layout = ({
  children,
  seoProps,
  shouldIncludeNavheader = true,
  currentPage = null,
}) => {
  return (
    <main>
      <Seo {...seoProps} />
      {shouldIncludeNavheader ? <NavHeader currentPage={currentPage} /> : null}
      {children}
      <Footer />
    </main>
  )
}
Layout.propTypes = {
  currentPage: PropTypes.number,
  shouldIncludeNavheader: PropTypes.bool,
  children: PropTypes.node.isRequired,
  seoProps: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    lang: PropTypes.string,
    canonicalUrl: PropTypes.string,
    image: PropTypes.string,
  }),
}
